import {Input} from './validatable-input-field';

function createPasswordSuccessMessage(input) {
  var result = document.createElement('small');
  result.classList.add('u-icon', 'u-icon--positive-feedback', 'password-validity-info', 'u-hidden');
  var validMessage = input.getAttribute('data-valid-message') || 'Password meets security criteria';
  var successText = document.createTextNode(validMessage);
  result.appendChild(successText);
  return result;
}

function removePasswordValidationClasses(inputField) {
  inputField.removeClass('input--invalid');
  inputField.removeClass('input--valid');
}

function forCreate(element, validators, contextualHelp) {

  var successMessage = createPasswordSuccessMessage(element);
  element.parentNode.appendChild(successMessage);

  function showValidPasswordMessage(inputField) {
    inputField.replace('input--invalid', 'input--valid');
    contextualHelp.classList.add('u-hidden');
    successMessage.classList.remove('u-hidden');
  }

  function highlightIncompletePasswordMessage(inputField) {
    inputField.replace('input--valid', 'input--invalid');
    contextualHelp.classList.add('u-icon--negative-feedback');
    inputField.addAnalyticsError(contextualHelp.innerText);
  }

  function showContextualHelp(inputField) {
    inputField.removeClass('input--valid');
    contextualHelp.classList.remove('u-hidden');
    contextualHelp.classList.remove('u-icon--negative-feedback');
    successMessage.classList.add('u-hidden');
  }

  function clearErrorMessaging(inputField) {
    removePasswordValidationClasses(inputField);
    contextualHelp.classList.remove('u-icon--negative-feedback');
  }

  return Input.validatable(element, {
    validators: validators,
    onValid: showValidPasswordMessage,
    onInvalid: showContextualHelp,
    onIncomplete: highlightIncompletePasswordMessage,
    onCorrection: clearErrorMessaging,
    onClear: clearErrorMessaging
  });
}

function forEntry(element) {

  function displayIncompleteErrorMessage(inputField) {
    inputField.replace('input--valid', 'input--invalid');
    inputField.showErrorMessage();
  }

  function removePasswordErrorMessage(inputField) {
    inputField.hideErrorMessage();
  }

  function displayValidField(inputField) {
    inputField.replace('input--invalid', 'input--valid');
    inputField.hideErrorMessage();
  }

  function createErrorNode(errorClass) {
    var errorMessage = document.createElement('small');
    errorMessage.classList.add('u-icon');
    errorMessage.classList.add('u-icon--negative-feedback');
    errorMessage.classList.add(errorClass);
    return errorMessage;
  }

  return Input.validatable(element, {
    errorNode: createErrorNode('password-valid-info'),
    onIncomplete: displayIncompleteErrorMessage,
    onCorrection: removePasswordErrorMessage,
    onValid: displayValidField,
    onClear: removePasswordValidationClasses
  });
}

export var passwordInput = {
  forCreate,
  forEntry
};
